module.exports = __webpack_public_path__ + "assets/5b4193cb5abb6ab0dc13bcd8031f9ac5.jpg";